import keyMirror from "keymirror";

const actions = {
  GET_HUB_RECONCILIATION_LIST: null,
  GET_HUB_RECONCILIATION_LIST_SUCCESS: null,
  GET_HUB_RECONCILIATION_LIST_ERROR: null,
  GET_HUB_RECONCILIATION_LIST_CLEAR: null,

  START_HUB_RECONCILIATION: null,
  START_HUB_RECONCILIATION_SUCCESS: null,
  START_HUB_RECONCILIATION_ERROR: null,
  START_HUB_RECONCILIATION_CLEAR: null,

  SCAN_BARCODE: null,
  SCAN_BARCODE_SUCCESS: null,
  SCAN_BARCODE_ERROR: null,
  SCAN_BARCODE_CLEAR: null,

  CLOSE_HUB_RECONCILIATION: null,
  CLOSE_HUB_RECONCILIATION_SUCCESS: null,
  CLOSE_HUB_RECONCILIATION_ERROR: null,
  CLOSE_HUB_RECONCILIATION_CLEAR: null,

  GET_REPORT_DATA: null,
  GET_REPORT_DATA_SUCCESS: null,
  GET_REPORT_DATA_ERROR: null,
  GET_REPORT_DATA_CLEAR: null,
};

export default keyMirror(actions);
